import { createQueryKeys } from '@lukemorales/query-key-factory';

export const repoQueryKeys = createQueryKeys('repos', {
  byId: (installationId: number) => [installationId],
});
